module.exports = {
    locale: navigator.language.split('-')[0],
    fallbackLocale: 'en',
    enableInSFC: true
}



//////////////////
// WEBPACK FOOTER
// ./config/i18n.config.js
// module id = DoET
// module chunks = 1